import { ViewEmployeeUiStore } from '../stores/ViewEmployeeUiStore'

export const setRolesOnSomePvz = (uiStore: ViewEmployeeUiStore) => {
  uiStore.setELockRoleList([])

  uiStore.employeeRoleList.forEach((roleItem) => {
    if (roleItem.id) {
      if (roleItem.roleWasChangedInModal) {
        roleItem.setRole(uiStore.selectedRole)

        uiStore.setELockRoleList([
          ...uiStore.eLockRoleList,
          { user_id: uiStore.selectedUserId, pickpoint_id: roleItem.id, elock_permission: uiStore.selectedELockRole },
        ])
      } else {
        roleItem.setRole(roleItem.cachedRole)

        const cachedELockRoleItem = uiStore.employeeELockRoleStore.getEntity(roleItem.id)

        if (cachedELockRoleItem) {
          const eLockRole = uiStore.eLockRoleList.find((item) => item.pickpoint_id === cachedELockRoleItem.id)

          if (eLockRole) {
            eLockRole.elock_permission = cachedELockRoleItem.cachedRole
          }
        } else {
          uiStore.setELockRoleList(uiStore.eLockRoleList.filter((item) => item.pickpoint_id !== roleItem.id))
        }
      }
    }
  })
}
